var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"getTitle"}},[_c('div',{staticClass:"txt",style:(_vm.colorSty)},[_vm._v("获得称号")]),_c('div',{staticClass:"title",style:(_vm.titleBg)},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }